/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

import Checkbox from 'live/components/ui/TriStateCheckbox'
import i18n from 'live/services/i18n'

import { IAlarmsAsset } from 'plugin-codaf-risk-ext-bowtie/BowtieAlarms/BowtieAlarms'
import { ResourceCard } from 'plugin-codaf-risk-ext-bowtie/BowtieAlarmsNotificationSettings/components/ResourceCard/ResourceCard'
import { IAlarmGroup } from 'plugin-codaf-risk-ext-bowtie/types/alarms'

import { NewGroupSubscriptionsContainer, BowtieSelector } from './styles'

interface IProps {
    assets: IAlarmsAsset[]
    selectedBowties: Map<number, Map<number, number[]>>
    setSelectedBowties: React.Dispatch<React.SetStateAction<Map<number, Map<number, number[]>>>>
    setAlarmGroup?: (group: IAlarmGroup) => void
    alarmGroup?: IAlarmGroup
}

export const NewGroupSubscriptions: React.FC<IProps> = ({
    assets,
    selectedBowties,
    setSelectedBowties,
    setAlarmGroup,
    alarmGroup
}) => {
    const [checkedBox, setCheckedBox] = useState(false)
    const [indeterminateBox, setIndeterminateBox] = useState(false)
    const [checkedAsset, setChecketAsset] = useState<Set<number>>(new Set())

    const handleCheckedState = (): { checked: boolean; indeterminate: boolean } => {
        return { checked: checkedBox, indeterminate: indeterminateBox }
    }

    const handleAssetCheckedState = (): void => {
        if (checkedBox) {
            setSelectedBowties(new Map())
            setCheckedBox(false)
        } else {
            const assetsMap = new Map()
            assets.map(asset => {
                const operations = new Map()
                asset.operations.map(operation => {
                    const bowties = []
                    operation.bowties.map(bowtie => {
                        bowties.push(bowtie.id)
                    })
                    operations.set(operation.id, bowties)
                })
                assetsMap.set(asset.id, operations)
            })
            setSelectedBowties(new Map([...assetsMap.entries()]))
            setCheckedBox(true)
        }
    }

    useEffect(() => {
        if (assets) {
            if (checkedAsset.size === assets.length) {
                setCheckedBox(true)
            } else {
                setCheckedBox(false)
            }
            if (checkedAsset.size > 0) {
                if (checkedAsset.size === assets.length) {
                    setIndeterminateBox(false)
                } else {
                    setIndeterminateBox(true)
                }
            }
            if (checkedAsset.size <= 0) {
                setIndeterminateBox(false)
            }
        }
    }, [checkedAsset, selectedBowties])

    return (
        <NewGroupSubscriptionsContainer>
            <div className={'subscriptions-header'}>
                <div className={'subscriptions-title'}>{i18n('Subscriptions').toUpperCase()}</div>
                <div className={'subscriptions-subtitle'}>
                    {i18n('Resources').toUpperCase()}
                    <Checkbox
                        {...handleCheckedState()}
                        onChange={() => handleAssetCheckedState()}
                        id="alarmgroup-bowtie-edition"
                    />
                </div>
            </div>

            <BowtieSelector>
                {assets?.map((asset, index) => (
                    <ResourceCard
                        alarmGroup={alarmGroup}
                        setAlarmGroup={setAlarmGroup}
                        asset={asset}
                        key={index}
                        assetsSelectedBowties={selectedBowties.get(asset.id) ?? new Map()}
                        setAssetSelectedBowties={operations => {
                            selectedBowties.set(asset.id, operations)
                            setSelectedBowties(new Map([...selectedBowties.entries()]))
                        }}
                        checkedAsset={checkedAsset}
                    />
                ))}
            </BowtieSelector>
        </NewGroupSubscriptionsContainer>
    )
}
